export default "__VITE_ASSET__Bnr53KbY__"